import { render, staticRenderFns } from "./FreestyleContent.vue?vue&type=template&id=2323f3c6&scoped=true&"
import script from "./FreestyleContent.vue?vue&type=script&lang=js&"
export * from "./FreestyleContent.vue?vue&type=script&lang=js&"
import style0 from "./FreestyleContent.vue?vue&type=style&index=0&id=2323f3c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323f3c6",
  null
  
)

export default component.exports